import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { ThongkeService } from '../services/thongke.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  showFormThongKe = true;
  displaySideBar = false;
  tkNamHienTai = 0;
  tkThangHienTai = 0;
  soLuongHsThangHienTaiColor = '#ff0012';
  soLuonghsNamHienTaiColor = '#0f68ad';
  soLuonghsNamTruocColor = '#207f3b';
  slTheoNam!: string;
  slTheoThang!: string;
  slTheoNamTruoc!: string;

  dataChart: any;
  optionChart: any;
  constructor(private messageService: MessageService, private router: Router, private thongKeService: ThongkeService) {

  }
  ngOnInit(): void {
    this.optionChart = {
      plugins: {
        legend: {
          labels: {
            color: '#ebedef'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#ebedef'
          },
          grid: {
            color: 'rgba(255,255,255,0.2)'
          }
        },
        y: {
          ticks: {
            color: '#ebedef'
          },
          grid: {
            color: 'rgba(255,255,255,0.2)'
          }
        }
      }
    };
    this.slTheoThang = '0';
    this.messageService.add({
      severity: 'success',
      summary: 'Thông báo',
      detail: 'Đã đăng nhập thành công!'
    });
    let namHienTai = new Date().getFullYear();
    this.tkNamHienTai = namHienTai;
    let thangHienTai = new Date().getMonth() + 1;
    this.tkThangHienTai = thangHienTai;
    this.thongKeService.thongketheonam(namHienTai).subscribe((resp: any) => {
      if (resp != undefined && resp != null) {
        this.slTheoNam = resp.namhientai.toString();
        this.slTheoNamTruoc = resp.namtruoc.toString();
        console.log(this.slTheoNam);
      }
    });
    this.thongKeService.thongketheothang(thangHienTai, namHienTai).subscribe((resp: any) => {
      if (resp != undefined && resp != null) {
        this.slTheoThang = resp.thanghientai.toString();
        let dataLabel: string[] = [];
        let dataCacThang: number[] = [];
        for (let i = 0; i < 12; i++) {
          dataLabel.push('Tháng ' + (i + 1).toString());
          if (resp.data[i] != undefined && resp.data[i] != null) {
            dataCacThang.push(resp.data[i].soluong);
          }
        }
        // Build chart data
        this.dataChart = {
          labels: dataLabel,
          datasets: [
            {
              label: 'Số hồ sơ',
              backgroundColor: '#42A5F5',
              data: dataCacThang
            }
          ]
        };
        // console.log(resp);
      }
    });
  }


  logout(link: string) {
    localStorage.setItem('isLoginedIn', 'false');
    this.router.navigate(['/']);
  }

  nhanSu(link: string) {
    this.router.navigate(['/nhansu']);
  }

  loaiHopDong(link: string) {
    this.router.navigate(['/loaihopdong']);
  }

  nguoiYeuCau(link: string) {
    this.router.navigate(['/nguoiyeucau']);
  }

  soCai(link: string) {
    this.router.navigate(['/socai']);
  }

  timKiem(link: string) {
    this.router.navigate(['/timkiem']);
  }

  toogleFormThongKe(event: any) {
    this.showFormThongKe = !this.showFormThongKe;
  }

  thongke(event: any) {
    this.thongKeService.thongketheonam(this.tkNamHienTai).subscribe((resp: any) => {
      if (resp != undefined && resp != null) {
        this.slTheoNam = resp.namhientai.toString();
        this.slTheoNamTruoc = resp.namtruoc.toString();
        console.log(this.slTheoNam);
      }
    });
    let thangCuoiCung = 12;
    let namHienTai = new Date().getFullYear();
    if (this.tkNamHienTai >= namHienTai) {
      thangCuoiCung = 1;
    }
    this.thongKeService.thongketheothang(thangCuoiCung, this.tkNamHienTai).subscribe((resp: any) => {
      if (resp != undefined && resp != null) {
        this.slTheoThang = resp.thanghientai.toString();
        let dataLabel: string[] = [];
        let dataCacThang: number[] = [];
        for (let i = 0; i < 12; i++) {
          dataLabel.push('Tháng ' + (i + 1).toString());
          if (resp.data[i] != undefined && resp.data[i] != null) {
            dataCacThang.push(resp.data[i].soluong);
          }
        }
        // Build chart data
        this.dataChart = {
          labels: dataLabel,
          datasets: [
            {
              label: 'Số hồ sơ',
              backgroundColor: '#42A5F5',
              data: dataCacThang
            }
          ]
        };
        // console.log(resp);
      }
    });
  }
}
